import { Component, Injector, OnInit } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { PlaceDto } from '@proxy/places';
import { UserPlaceService as UserPlaceServiceProxy } from '@proxy/user-places/user-place.service';
import { firstValueFrom } from 'rxjs';
import { UserPlaceService } from '../../services/user-place.service';

@Component({
    selector: 'app-change-place-modal',
    templateUrl: './change-place-modal.component.html',
    standalone: false
})
export class ChangePlaceModalComponent extends AppBaseComponent implements OnInit {

  isVisible = false;
  placesItems: PlaceDto[] = [];
  currentPlace: PlaceDto;

  constructor(
    injector: Injector,
    private readonly _userPlaceServiceProxy: UserPlaceServiceProxy,
    private readonly _userPlaceService: UserPlaceService) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadCurrentUserPlace();
  }

  show(): void {
    this.getAvailablePlaces();
  }

  async updatePlace(place: PlaceDto): Promise<void> {
    try {
      this.showLoading();
      await firstValueFrom(this._userPlaceServiceProxy.updateCurrentUserPlaceByPlaceId(place.id));
    } finally {
      this.hideLoading();
      this._userPlaceService.refreshCurrentUserPlace();
    }
  }

  private async loadCurrentUserPlace(): Promise<void> {
    this.currentPlace = await this._userPlaceService.getCurrentUserPlace();
  }

  private async getAvailablePlaces(): Promise<void> {
    try {
      this.showLoading();
      this.placesItems = await firstValueFrom(this._userPlaceServiceProxy.getCurrentUserAvailablePlaces());
    } finally {
      this.isVisible = true;
      this.hideLoading();
    }
  }
}
